<template>
  <div class="header">
    <el-row :gutter="5" type="flex" justify="center">
      <el-col :xs="8" :sm="6" :md="5" :lg="4" :xl="2">
        <div class="logo fl">
          <img src="@/assets/images/logo.png" alt="" />
          <p>飞康生物</p>
        </div></el-col
      >
      <el-col :xs="0" :sm="2" :md="5" :lg="6" :xl="6"><div></div></el-col>
      <el-col :xs="3" :sm="6" :md="2" :lg="2" :xl="2"
        ><router-link to="/" exact tag="a" class="nav" > 首页 </router-link></el-col
      >
      <el-col :xs="3" :sm="6" :md="2" :lg="2" :xl="2"
        ><router-link to="/product" tag="a" class="nav">
          产品中心
        </router-link></el-col
      >
      <el-col :xs="3" :sm="6" :md="2" :lg="2" :xl="2"
        ><router-link
          to="/information"
          tag="a"
          class="nav"
        >
          新闻动态
        </router-link></el-col
      >
      <el-col :xs="3" :sm="6" :md="2" :lg="2" :xl="2"
        ><router-link
          to="/aboutus"
          tag="a"
          class="nav"
        >
          关于我们
        </router-link></el-col
      >
      <el-col :xs="3" :sm="6" :md="2" :lg="2" :xl="2"
        ><router-link
          to="/cooperation"
          tag="a"
          class="nav"
        >
          联系我们
        </router-link></el-col
      >
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {};
  },
  methods: {
    handleGo(target) {
      this.$router.push(target);
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 1250px;
  margin: 0 auto;
}
.nav {
  height: 70px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.router-link-active {
  font-weight: bold;
  color: rgb(100, 16, 173);
  background: url(@/assets/images/nav.png) center top no-repeat;
}
.header {
  height: 70px;
  width: 100%;
  background-color: rgb(255, 255, 255);
  border-bottom: 2px solid rgb(100, 16, 173);
  position: fixed;
  z-index: 3;
}
/* 左右浮动 */
.el-col {
  border-radius: 4px;
}
.logo {
  display: flex;
  align-items: center;
  line-height: 70px;
  img {
    height: 40px;
    width: 40px;
    margin-right: 10px;
  }
}
.nav:hover {
  font-weight: bold;
  color: rgb(100, 16, 173);
  background: url(@/assets/images/nav.png) center top no-repeat;
}
</style>
